import { ApolloClient, NormalizedCacheObject } from '@apollo/client';

import { errorLink } from '../links';
import { API } from 'utils';
import { cache } from '../cache';

const { createUploadLink } = require("apollo-upload-client");

const httpLink = createUploadLink({
  uri: `${API.DMSClient.url}`,
});

const dmsLink = errorLink().concat(httpLink);

export const dmsClient = new ApolloClient<NormalizedCacheObject>({
	link: dmsLink,
	cache,
	queryDeduplication: false,
	connectToDevTools: true,
	defaultOptions: {
		watchQuery: {
			fetchPolicy: 'cache-and-network',
		},
		query: {
			fetchPolicy: 'network-only',
		},
	},
});

export default dmsClient;
